'use strict';

angular.module('ntmApp').factory('RoomTilesViewModel', ['$q', 'DailyPlanService', 'OtherActivitiesViewModel', 'DailyPlanResourcePool', 'FlashService', 'Constants', 'Utils', 'DragFromResourcePool', 'DraggingToResourcePoolActions', 'DragStaffIntoResourcePool', 'NonDailyActivities','SignalR',
    function ($q, DailyPlanService, OtherActivitiesViewModel, DailyPlanResourcePool, FlashService, Constants, Utils, DragFromResourcePool, DraggingToResourcePoolActions, DragStaffIntoResourcePool, NonDailyActivities, SignalR) {

    function RoomTilesViewModel(context) {

        var self = this;


        self.load = function (doNotReload) {

            self.isLoading = true;

            loadTiles().then(function () {
                self.isLoading = false;
            });

            if (!doNotReload) {
                if (!self.ResourcePool.initialized) {
                    self.ResourcePool.load();
                }
            }

            loadStatistics();

            loadFilters();

            self.NonDailyActivities.load();
        };

        self.performFiltering = function () {
            if (self.roomTilesOriginal) {
                self.roomTiles = self.roomTilesOriginal.filter(isRoomTileMatchedByFilters);
            }
        };

        self.showRoomActivities = function (room) {

            var request = context.getViewModeAndSelectedDate();
            request.roomNumber = room.title;
            request.facilityCode = room.facilityCode.trim();

            var loadingModal = FlashService.Loading();
            DailyPlanService.GetRoomActivities(request).then(function (result) {

                var data = {
                    isCurrentDateDisplayed: context.TopBar.isCurrentDateDisplayed(),
                    isPastDateDisplayed: context.TopBar.isPastDateDisplayed(),
                    isFutureDateDisplayed: context.TopBar.isFutureDateDisplayed(),
                    room: room.title,
                    activities: result.data.roomActivityGroups,
                    activityType: Constants.ActivityTypes,
                    getTotalDurationOfGroup: function (roomActivity) {
                        return roomActivity.items ? roomActivity.items.sumOf('totalDuration') : 0;
                    },
                    getTotalDuration: function (groups) {
                        var sum = 0;

                        if (groups) {
                            groups.forEach(function (group) {
                                sum += group.items ? group.items.sumOf('totalDuration') : 0;
                            });
                        }

                        return sum;
                    },

                    getUnAssignedDuration: function (groups) {
                        var sum = 0;

                        if (groups) {
                            groups.forEach(function (group) {
                                sum += group.items ? group.items.filter(function (item) {
                                    return !item.assignment;
                                }).sumOf('totalDuration') : 0;
                            });
                        }

                        return sum;
                    },
                    getGroupStatus: function (group) {

                        var byGroupStatus = group.items.groupBy('activityStatusId');

                        if (context.TopBar.isPastDateDisplayed()) {

                            if (byGroupStatus.length > 1) {
                                return context.TopBar.activityStatuses[4].value;
                            } else {

                                if (byGroupStatus[0].key === context.TopBar.activityStatuses[2].id) {
                                    return context.TopBar.activityStatuses[2].value;
                                } else {
                                    return context.TopBar.activityStatuses[4].value;
                                }
                            }
                        } else {

                            if (byGroupStatus.length > 1) {
                                return context.TopBar.activityStatuses[1].value;
                            } else {

                                if (byGroupStatus[0].key === context.TopBar.activityStatuses[0].id) {
                                    return context.TopBar.activityStatuses[0].value;
                                } else if (byGroupStatus[0].key === context.TopBar.activityStatuses[2].id) {
                                    return context.TopBar.activityStatuses[2].value;
                                } else {
                                    return group.items[0].status;
                                }
                            }
                        }
                    },
                    getGroupIcon: function (group) {

                        var byGroupStatus = group.items.groupBy('activityStatusId');

                        if (context.TopBar.isPastDateDisplayed()) {

                            if (byGroupStatus.length > 1) {
                                return context.TopBar.activityStatuses[4].icon;
                            } else {

                                if (byGroupStatus[0].key === context.TopBar.activityStatuses[2].id) {
                                    return context.TopBar.activityStatuses[2].icon;
                                } else {
                                    return context.TopBar.activityStatuses[4].icon;
                                }
                            }
                        } else {

                            if (byGroupStatus.length > 1) {
                                return context.TopBar.activityStatuses[1].icon;
                            } else {

                                if (byGroupStatus[0].key === context.TopBar.activityStatuses[0].id) {
                                    return context.TopBar.activityStatuses[0].icon;
                                } else if (byGroupStatus[0].key === context.TopBar.activityStatuses[2].id) {
                                    return context.TopBar.activityStatuses[2].icon;
                                } else {
                                    return group.items[0].statusIcon;
                                }
                            }
                        }
                    },

                    expandAllDialogRoomActivities: function () {
                        result.data.roomActivityGroups.forEach(function (group) {
                            group.expanded = true;
                        });
                    },

                    collapseAllDialogRoomActivities: function () {
                        result.data.roomActivityGroups.forEach(function (group) {
                            group.expanded = false;
                        });
                    },

                    getGroupingStaffSummaries: function (group) {
                        var uniqueIds = Array.from(new Set(group.items.map(function (item) { return item.assignmentId; })));
                        var groupedItems = [];

                        uniqueIds.forEach(function (id) {
                            if (id !== null && id !== undefined) {
                                groupedItems.push(group.items.filter(function (item) { return item.assignmentId === id; }));
                            }
                        });

                        var groupingSummary = [];

                        groupedItems.forEach(function (groupingItem) {
                            groupingSummary.push({
                                assigneeId: groupingItem[0].assignmentId ? groupingItem[0].assignmentId : null,
                                assigneeName: groupingItem[0].assignment ? groupingItem[0].assignment : null,
                                totalActivityDurations: groupingItem.sumOf('totalDuration')
                            });
                        });

                        return groupingSummary;
                    }
                };

                result.data.roomActivityGroups.forEach(function (group) {
                    group.icons = getUniqueIcons(group.items);
                });

                loadingModal.dismiss();
                Utils.OpenModal("", "ng1/src/dailyPlan/views/level2/roomInfo.html", null, data, 'room-activities-dialog', null, false);
            });

        };

        self.showRoomsDetails = function (room) {

            var request = context.getViewModeSelectedDateAndLocation();

            self.isLoading = true;

            DailyPlanService.GetRoomBreadcrumb(request).then(function (result) {
                context.TopBar.BreadCrumbs.setRooms(result.data.roomBreadcrumbs);
                context.TopBar.BreadCrumbs.changeRoomById(room);
            });
        };

        self.showUnplanedActivitiesButton = function (button) {


            if (!button.jsonProperties || !button.jsonProperties.display) {
                return true;
            }

            return button.jsonProperties.display.level2;
        };

        self.toggleStatistics = function () {
            self.showStatistics = !self.showStatistics;
            self.showResourcePool = false;
            self.showNonDailyActivities = false;

            saveRightPanesState();
        };

        self.toggleResourcePool = function () {
            self.showResourcePool = !self.showResourcePool;
            self.showStatistics = false;
            self.showNonDailyActivities = false;

            saveRightPanesState();
        };

        self.toggleNonDailyActivities = function () {
            self.showNonDailyActivities = !self.showNonDailyActivities;
            self.showStatistics = false;
            self.showResourcePool = false;

            saveRightPanesState();
        };

        self.isRightPanelOpened = function () {
            return self.showStatistics || self.showResourcePool || self.showNonDailyActivities;
        };

        self.getInfoForDraggingAction = function () {

            var targetRoomTile = self.roomTiles.firstOrDefault(function (tile) {
                return tile.dndTarget && tile.dndTarget.length > 0;
            });

            if (targetRoomTile) {

                return {
                    roomNumber: targetRoomTile.title,
                    facilityCode: targetRoomTile.facilityCode,
                    date: moment(context.TopBar.dateDisplayed),
                    isExistingAssignments: self.ResourcePool.replaceAssignments || false,
                    isSingleActivity: false,
                    activities: targetRoomTile.activities,
                    totalHours:targetRoomTile.totalHours,
                    changeableHours: targetRoomTile.changeableHours,
                    unAssignedHours: targetRoomTile.unAssignedHours
                };
            }

            return {};
        };

        self.updateViewOnWebSocketsResponse = function (callBackData) {

            var dateDisplayed = moment(context.TopBar.dateDisplayed).startOf('day');
            var socketDate = moment(callBackData.date).startOf('day');

            if (dateDisplayed.isSame(socketDate)) {
                
                var tilesToUpdate = self.roomTilesOriginal.filter(function (tile) {
                    return callBackData.dailySocketFacilities.some(function (facility) {
                        return facility.roomNumber === tile.title || tile.roomAssignees.some(function (assignee) {
                            return assignee.personId === callBackData.draggedAssigneeId || callBackData.previousAssigneeIdsList.some(function (previousAssigneeId) { return assignee.personId === previousAssigneeId; });
                        });
                    });
                });

                if (tilesToUpdate && tilesToUpdate.length > 0) {

                    tilesToUpdate.forEach(function (tile) {
                        self.roomTiles.forEach(function (roomTile) {
                            if (roomTile.title === tile.title) {
                                roomTile.roomTileChanging = true;
                            }
                        });
                    });

                    var request = context.getViewModeSelectedDateAndLocation();
                    request.rooms = tilesToUpdate.map(function (tile) {
                        return tile.title;
                    });

                    self.ResourcePool.load();
                    self.NonDailyActivities.load();
                    loadStatistics();
                    loadFilters();

                    DailyPlanService.GetDetailsTiles(request).then(function (result) {

                        tilesToUpdate.forEach(function (tile) {

                            var newTile = result.data.firstOrDefault(function (responseTile) {
                                return tile.title === responseTile.title;
                            });

                            if (newTile) {
                                tile.overAssignedCount = newTile.overAssignedCount;
                                tile.activities = newTile.activities; // update activity.assignmentId for all activities
                                tile.roomAssignees = newTile.roomAssignees;
                                tile.unAssignedActivities = newTile.unAssignedActivities;
                                tile.unAssignedHours = newTile.unAssignedHours;
                                tile.assignedActivities = newTile.assignedActivities;
                            }

                            self.roomTiles.forEach(function (roomTile) {
                                if (roomTile.title === tile.title) {
                                    roomTile.roomTileChanging = false;
                                }
                            });
                        });

                        checkAssigneeDraggingPossibilityBasedOnActivityStatus(self.roomTilesOriginal);
                        self.performFiltering();
                    });
                }
            }
        };

        self.confirmViewLeaving = function (nextAction) {

            if (nextAction) {
                nextAction();
            }
        };

        self.isChanged = function () {
            return false;
        };

        self.areFiltersApplied = function () {
            var filtersApplied = false;

            for (var option in self.selectedFilterOptions) {

                if (self.selectedFilterOptions.hasOwnProperty(option) && self.selectedFilterOptions[option]) {

                    if (self.selectedFilterOptions[option]) {
                        filtersApplied = true;

                        break;
                    }
                }
            }

            if (filtersApplied) {
                return true;
            }

            return false;
        };

        self.filterPresentStaffByRoomSpecies = function (roomTile) {
            self.ResourcePool.clearFilter(self.ResourcePool.Filter.BySkillSetFilter);
            self.ResourcePool.Filter.StaffSkillsFilter.filterItem = { value: "byRoom", title: "By Room Skills" };
            self.ResourcePool.Filter.ByRoomSkillsFilter.filterItem = roomTile;
            self.ResourcePool.Filter.ByRoomSkillsFilter.filterItem.id = roomTile.title;
            self.ResourcePool.Filter.ByRoomSkillsFilter.filterItem.value = roomTile.title;

            if (!self.showResourcePool) {
                self.toggleResourcePool();
            }

            self.ResourcePool.performFiltering();
        };

        self.clearAllFilters = function () {

            self.selectedFilterOptions = {};

            self.performFiltering();
        };

        self.defaultDndTargets = function () {

            self.ResourcePool.dndTarget = [];

            if (self.roomTiles) {
                self.roomTiles.forEach(function (tile) {
                    tile.dndTarget = [];
                });
            }
        };

        self.doesActivityStatusAllowActivityChanging = function (activityStatusId) {
            return activityStatusId === Constants.ActivityStatus.NotStarted || activityStatusId === Constants.ActivityStatus.Lapsed;
        };

        function saveRightPanesState() {
            sessionStorage.showDailyPlanStatisticsPane = self.showStatistics || "";
            sessionStorage.showDailyPlanResourcePoolPane = self.showResourcePool || "";
            sessionStorage.showDailyPlanNonDailyActivitiesPane = self.showNonDailyActivities || "";
            sessionStorage.showDailyPlanRoomInfo = "";
        }

        function loadTiles() {

            var deferred = $q.defer();
            var request = context.getViewModeSelectedDateAndLocation();

            DailyPlanService.GetDetailsTiles(request).then(function (result) {

                if (result.success) {
                    self.roomTiles = result.data;
                    checkAssigneeDraggingPossibilityBasedOnActivityStatus(self.roomTiles);

                    self.defaultDndTargets();

                    self.roomTilesOriginal = angular.copy(self.roomTiles);
                    self.performFiltering();
                }

                deferred.resolve();
            });

            return deferred.promise;
        }

        function loadStatistics() {

            var deferred = $q.defer();
            var request = context.getViewModeSelectedDateAndLocation();

            self.statisticChanging = true;
            DailyPlanService.GetDetailsStatistics(request).then(function (result) {

                if (result.success) {
                    self.statistic = result.data;
                }
                
                self.statisticChanging = false;
                deferred.resolve();
            });

            return deferred.promise;
        }

        function loadFilters() {

            var deferred = $q.defer();
            var request = context.getViewModeSelectedDateAndLocation();

            self.filtersDisabled = true;
            DailyPlanService.GetDetailsFilters(request).then(function (result) {

                if (result.success) {
                    self.filtersDataSource.rooms = result.data.rooms;
                    self.filtersDataSource.staff = result.data.staff;
                    self.filtersDataSource.species = result.data.species;
                    self.filtersDataSource.roomTypes = result.data.roomTypes;
                    self.filtersDataSource.roomStatus = result.data.roomStatus;
                }

                self.filtersDisabled = false;
                deferred.resolve();          
            });

            return deferred.promise;
        }

        function reloadView() {

            var loadingModal = FlashService.Loading();

            $q.all([loadTiles(), loadStatistics(), loadFilters(), self.ResourcePool.load()])
              .then(function () {
                  loadingModal.dismiss();
              });
            self.NonDailyActivities.load();
        }

        function isRoomTileMatchedByFilters(roomTile) {

            if (!Utils.IsTypeheadEmpty(self.selectedFilterOptions.room)) {
                if ((self.selectedFilterOptions.room.room || self.selectedFilterOptions.room) !== roomTile.title) {
                    return false;
                }
            }

            if (!Utils.IsTypeheadEmpty(self.selectedFilterOptions.staffName)) {

                var containsSelectedStaff = roomTile.roomAssignees.some(function (staff) {
                    return self.selectedFilterOptions.staffName.id ? staff.personId === self.selectedFilterOptions.staffName.id : self.selectedFilterOptions.staffName === staff.name;
                });

                if (!containsSelectedStaff) {
                    return false;
                }
            }

            if (self.selectedFilterOptions.selectedRoomStatus) {
                if (self.selectedFilterOptions.selectedRoomStatus.id !== roomTile.roomStatusId) {
                    return false;
                }
            }

            if (self.selectedFilterOptions.selectedRoomType) {
                var filterRoomType = self.selectedFilterOptions.selectedRoomType.id ? self.selectedFilterOptions.selectedRoomType.value : null;
                if (filterRoomType !== roomTile.roomType) {
                    return false;
                }
            }

            if (self.selectedFilterOptions.selectedSpeciesItem) {

                var containsSpecies = roomTile.species.some(function (speciesItem) {
                    return self.selectedFilterOptions.selectedSpeciesItem.id === speciesItem.code;
                });

                if (!containsSpecies) {
                    return false;
                }
            }

            if (self.selectedFilterOptions.hasUnAssigned || self.selectedFilterOptions.overAllocated || self.selectedFilterOptions.underAllocated) {

                if (self.selectedFilterOptions.hasUnAssigned && roomTile.unAssignedActivities > 0) {
                    return true;
                }

                if (self.selectedFilterOptions.overAllocated && roomTile.overAssignedCount > 0) {
                    return true;
                }

                if (self.selectedFilterOptions.underAllocated && roomTile.underAssignedount > 0) {
                    return true;
                }

                return false;

            } else {
                return true;
            }
        }

        function checkAssigneeDraggingPossibilityBasedOnActivityStatus(roomTiles) {
            roomTiles.forEach(function (roomTile) {
                roomTile.roomAssignees.forEach(function (assignee) {
                    assignee.hasChangeableActivities = roomTile.activities.some(function (activity) {
                        return activity.assignmentId === assignee.personId && self.doesActivityStatusAllowActivityChanging(activity.activityStatusId);
                    });
                });
            });
        }

        function onEndDragging() {

            if (SignalR.IsSupported()) {
                self.defaultDndTargets();
            } else {
                reloadView();
            }
        }

        function getUniqueIcons(activities) {

            var icons = activities.filter(function (activity) {
                return activity.activityIcon;
            }).map(function (activity) {
                return {
                    icon: Constants.ActivityTypes.getIconSrc(activity),
                    color: Constants.ActivityTypes.getIconColor(activity.activityIcon)
                };
            }).unique(function (icon1, icon2) {
                return icon1.icon === icon2.icon &&
                       icon1.color === icon2.color;
            });

            return icons;
        }

        function initialize() {
            self.filtersDataSource = {};
            self.selectedFilterOptions = {};

            self.ResourcePool = new DailyPlanResourcePool(context);
            self.NonDailyActivities = new NonDailyActivities(context);
            self.DragFromRoom = new DragStaffIntoResourcePool(context);
            
            self.DragToResourcePool = new DraggingToResourcePoolActions([self.DragFromRoom]);
            self.DragToResourcePool.onEndDragging(onEndDragging);
            self.DragToResourcePool.onStartDragging(function () {

                if (!self.showResourcePool) {
                    self.toggleResourcePool(); 
                }

                self.ResourcePool.selectPresentStaffTab();

                return true;
            });

            self.DragFromResourcePool = new DragFromResourcePool(self);
            self.DragFromResourcePool.onEndDragging(onEndDragging);
            self.DragFromResourcePool.onStartDragging(function () {
                return true;                
            });

            self.showStatistics = sessionStorage.showDailyPlanStatisticsPane ? true : false;
            self.showResourcePool = sessionStorage.showDailyPlanResourcePoolPane ? true : false;
            self.showNonDailyActivities = sessionStorage.showDailyPlanNonDailyActivitiesPane ? true : false;

            if (self.showStatistics && self.showResourcePool) {
                self.showStatistics = false;
            }

            if (self.showNonDailyActivities && self.showResourcePool) {
                self.showNonDailyActivities = false;
            }
        }

        initialize();
    }

    return (RoomTilesViewModel);

}]);
